import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { fetchRecordingsData, fetchRecordingFileData } from "./data/recordingsData"

const recordCount = parseInt(process.env.REACT_APP_RECORDCOUNT) || 20;
console.log('📏 recordCount configured as:', recordCount);

export const fetchRecordingFile = createAsyncThunk(
  'recordings/fetchRecordingFile',
  async (paramaters) => {
    try {
      const data = await fetchRecordingFileData(paramaters);
      console.log('fetchRecordingFile resp: ', paramaters, data)
      return data
    } catch (error) {
      console.log('recordings/fetchRecordingFile: ', error)
    }
  })

export const fetchRecordingsBatch = createAsyncThunk(
  'recordings/fetchRecordingsBatch',
  async (initialParams, { dispatch, rejectWithValue }) => {
    try {
      console.log('⚡ fetchRecordingsBatch triggered with:', initialParams);

      let params = JSON.parse(JSON.stringify(initialParams));
      const append = !!params.append;
      const searchId = params.SearchId;
      delete params.append;

      const result = await fetchRecordingsData(params, dispatch);

      console.log('✅ Returning', result.Results.length, 'calls. Next key:', result.LastEvaluatedKey);

      return {
        CallsTable: result.Results,
        LastEvaluatedKey: result.LastEvaluatedKey,
        SearchId: searchId,
        append
      };
    }
    catch (err) {
      console.log('❌ recordings/fetchRecordingsBatch: ', err)
      return rejectWithValue(err.message)
    }
  }
)

const recordingsSlice = createSlice({
  name: 'recordings',
  initialState: {
    recordings: [],
    recordingFile: '',
    status: 'idle',
    error: null,
    lastkey: {},
    recordingParams: {},
    searchId: 0,
  },
  reducers: {
    clearData(state) {
      state.recordings = [];
      state.recordingFile = '';
      state.recordingParams = {};
    },
    setRecordingParams(state, action) {
      state.recordingParams = action.payload;
      //console.log('setRecordingParams', state.recordingParams)
    },
    resetRecordingFile(state) {
      state.recordingFile = '';
    },
    appendRecordings(state, action) {
      if (action.payload.SearchId === state.searchId) {
        state.recordings = state.recordings.concat(action.payload.results);
        state.lastkey = action.payload.lastkey;
      }
    }
  },
  extraReducers: builder => builder

    //get recording file and add to recording obj
    .addCase(fetchRecordingFile.pending, (state, action) => {
      state.status = 'loading'
    })
    .addCase(fetchRecordingFile.fulfilled, (state, action) => {
      state.status = 'succeeded'
      //set fetched recording file
      console.log('fetchRecordingFile.fulfilled', action.payload)
      state.recordingFile = action.payload
    })
    .addCase(fetchRecordingFile.rejected, (state, action) => {
      state.status = 'failed'
      console.log('fetchRecordingFile.rejected error: ', action.error.message)
      state.error = action.error.message
    })

    //get recordings batch
    .addCase(fetchRecordingsBatch.pending, (state, action) => {
      const mode = action.meta.arg.mode;
      if (mode === 'more') {
        state.status = 'fetchingMore';
      } else {
        state.status = 'loading';
      }
      // Track the search ID so stale responses are ignored
      if (action.meta.arg.SearchId !== undefined) {
        state.searchId = action.meta.arg.SearchId;
      }
    })
    .addCase(fetchRecordingsBatch.fulfilled, (state, { payload }) => {
      if (payload.SearchId === state.searchId) {
        state.status = 'succeeded';
        // Update the lastkey from the final payload so the scroll handler
        // knows whether there are more pages to fetch
        state.lastkey = payload.LastEvaluatedKey;
      }
    })
    .addCase(fetchRecordingsBatch.rejected, (state, { payload, error }) => {
      state.status = 'failed'
      state.error = payload || error.message
      console.error('❌ Batch failed:', payload || error.message)
    })
})

export const { clearData, setRecordingParams, resetRecordingFile, appendRecordings } = recordingsSlice.actions

export const selectRecordingFile = (state) => state.recordings.recordingFile
export const selectRecordings = (state) => state.recordings.recordings
export const selectLastEvaluatedKey = (state) => state.recordings.lastkey

export default recordingsSlice.reducer